import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function DisclaimerPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('footerDisclaimer')} | CSSBuy Spreadsheet`;
  }, [t]);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <div className="max-w-6xl mx-auto px-4 md:px-6 pt-24 pb-4">
          <nav className="flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600 transition-colors">{t('breadcrumbHome')}</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-foreground-700">{t('footerDisclaimer')}</span>
          </nav>
        </div>

        <section className="py-8 md:py-12">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-6">
              {t('footerDisclaimer')}
            </h1>

            <div className="prose prose-lg max-w-none space-y-6">
              <p className="text-foreground-700 leading-relaxed">
                Este website é um recurso independente de informação. Não somos afiliados, associados, autorizados, endossados ou de qualquer forma oficialmente conectados a nenhum agente de compra, vendedor ou plataforma de e-commerce mencionado neste site.
              </p>

              <h2 className="font-heading text-xl text-foreground-950 mt-8">Informações e Precisão</h2>
              <p className="text-foreground-700 leading-relaxed">
                As informações contidas neste website são apenas para fins informativos. Embora nos esforcemos para manter as informações atualizadas e corretas, não fazemos representações ou garantias de qualquer tipo, expressas ou implícitas, sobre a integridade, precisão, confiabilidade, adequação ou disponibilidade das informações, produtos, serviços ou gráficos relacionados contidos no website.
              </p>

              <h2 className="font-heading text-xl text-foreground-950 mt-8">Sem Garantias</h2>
              <p className="text-foreground-700 leading-relaxed">
                Este website não garante produtos, vendedores, preços, serviços de envio, reembolsos ou transações de terceiros. Todo o uso das informações deste website é por sua conta e risco.
              </p>

              <h2 className="font-heading text-xl text-foreground-950 mt-8">Links Externos</h2>
              <p className="text-foreground-700 leading-relaxed">
                Este website pode conter links para websites externos que não são fornecidos ou mantidos por nós. Não temos controle sobre o conteúdo e práticas desses sites e não podemos aceitar responsabilidade por seu conteúdo.
              </p>

              <h2 className="font-heading text-xl text-foreground-950 mt-8">Verificação de Informações</h2>
              <p className="text-foreground-700 leading-relaxed">
                Sempre verifique as informações atuais antes de realizar qualquer pedido ou transação. Preços, disponibilidade, políticas e opções de envio podem mudar sem aviso prévio.
              </p>

              <div className="bg-primary-50 rounded-2xl p-6 md:p-8 mt-8">
                <p className="text-sm text-foreground-700 leading-relaxed">
                  <strong>Resumo:</strong> Este website é apenas um recurso de informação. Use as informações por sua conta e risco. Sempre verifique detalhes atuais diretamente com os serviços e vendedores antes de comprar.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}